import { ControlMapping, MappingQueryParams } from '../../types/dynamodb';
import {
  ListMappingsResponse,
  MappingsForControlResponse,
  NexusApiService,
} from '../nexusApiService';

/**
 * Backend-aligned UI client for NexusMappingService APIs.
 */
export class NexusMappingService {
  constructor(private readonly api: NexusApiService) {}

  async listMappings(
    params?: MappingQueryParams
  ): Promise<ListMappingsResponse> {
    return this.api.listMappings(params);
  }

  async getMapping(mappingId: string): Promise<ControlMapping> {
    return this.api.getMapping(mappingId);
  }

  async getMappingsForControl(
    controlId: string,
    params?: {
      status?: string;
      frameworkName?: string;
      frameworkVersion?: string;
      maxResults?: number;
      nextToken?: string;
    }
  ): Promise<MappingsForControlResponse> {
    return this.api.getMappingsForControl(controlId, params);
  }

  async getApprovedMappings(params?: {
    limit?: number;
    nextToken?: string;
    frameworkKey?: string;
    controlKey?: string;
  }): Promise<ListMappingsResponse> {
    return this.api.getApprovedMappings(params);
  }
}

